import { BaboorEnvironmentConfig } from '@baboor/baboor-core'

export const environment: BaboorEnvironmentConfig = {
    appName: 'Hair Style Club Dev',
    production: true,
    platform: 'dev',
    androidAppId: 'club.hairstyle.app',
    iosAppId: '',
    apiUrl: 'https://api-dev.hairstyle.club',
    authApiUrl: 'https://api-dev.hairstyle.club/v1',
    clientUrl: 'https://dev.hairstyle.club',
    holidayApiUrl: 'https://date.nager.at/api/v3/PublicHolidays',
}
